import { apiClient } from './client'
import type {
  V5AddressSummary,
  AddressDevicesResponse,
  ElectricityAggregationParams,
  ElectricityAggregationResponse,
} from '@/types/api'

function normalizeAddressSummary(raw: Record<string, unknown>): V5AddressSummary {
  const str = (key: string, ...fallbacks: string[]): string | undefined => {
    for (const k of [key, ...fallbacks]) {
      const v = raw[k]
      if (typeof v === 'string') return v
    }
    return undefined
  }
  return {
    addressUuid: str('addressUuid', 'address_uuid', 'uuid') ?? '',
    street: str('street'),
    houseNumber: str('houseNumber', 'house_number'),
    houseNumberAdd: str('houseNumberAdd', 'house_number_add'),
    city: str('city'),
    postalCode: str('postalCode'),
    country: str('country'),
  }
}

export function getAddresses(): Promise<V5AddressSummary[]> {
  return apiClient.get('/v5/addresses').then((res) => {
    const data = res.data as unknown
    let list: unknown[] = []
    if (Array.isArray(data)) {
      list = data
    } else if (data && typeof data === 'object') {
      const obj = data as Record<string, unknown>
      if (Array.isArray(obj.addresses)) list = obj.addresses
      else if (Array.isArray(obj.data)) list = obj.data
      else if (Array.isArray(obj.results)) list = obj.results
    }
    return list.map((item) =>
      normalizeAddressSummary(
        typeof item === 'object' && item !== null ? (item as Record<string, unknown>) : {}
      )
    )
  })
}

export function getAddressDevices(
  addressUuid: string,
  signal?: AbortSignal
): Promise<AddressDevicesResponse> {
  return apiClient
    .get<AddressDevicesResponse>(`/v5/addresses/${addressUuid}/devices`, { signal })
    .then((res) => res.data)
}

export function getAddressEnergyElectricityAggregation(
  addressUuid: string,
  params: ElectricityAggregationParams,
  signal?: AbortSignal
): Promise<ElectricityAggregationResponse> {
  return apiClient
    .get<ElectricityAggregationResponse>(
      `/v5/addresses/${addressUuid}/energy/electricity/aggregation`,
      {
        params: {
          aggregateType: params.aggregateType,
          resolution: params.resolution,
          fromDate: params.fromDate,
          toDate: params.toDate,
          timezone: params.timezone,
        },
        signal,
      }
    )
    .then((res) => res.data)
}
